import classNames from 'classnames';

type TyTimelineCardProps = {
  children?: React.ReactNode;
  badgePill: React.ReactNode;
  action?: React.ReactNode;
  title?: string;
  note?: string;
  variant?: 'regular' | 'deleted';
};

export const TyTimelineCard = ({
  children,
  badgePill,
  action,
  title,
  note,
  variant,
}: TyTimelineCardProps) => {
  return (
    <div
      className={classNames(
        `border-[1px] border-secondary-100 shadow-down-xs rounded-2xl overflow-clip relative flex-grow`,
        variant === 'deleted' && 'bg-secondary-50'
      )}
    >
      <div className="flex flex-row p-4">
        <div className="flex flex-col">
          {badgePill}
          <div
            className={classNames(
              variant === 'deleted' && 'text-secondary-400',
              'text-body-1-sm font-semibold mt-5'
            )}
          >
            {title}
          </div>
          {note != null ? (
            <div
              className={classNames(
                'text-body-2-md',
                variant === 'deleted' && 'text-secondary-400'
              )}
            >
              {note}
            </div>
          ) : null}
          {children}
        </div>
        <div className="mt-auto ml-auto flex flex-row items-center gap-2">
          {action}
        </div>
      </div>
    </div>
  );
};
